import React, { useMemo } from "react";
import { List, Tag, Typography } from "antd";
import { CrownOutlined } from "@ant-design/icons";
import { useTranslation } from "react-i18next";
import GamePage from "./GamePage";
import "./kingCup.css";

const { Text } = Typography;

const CARD_CONFIGS = [
    { key: "king", img: "/cards/king.png", color: "gold" },
    { key: "queen", img: "/cards/queen.png", color: "pink" },
    { key: "jack", img: "/cards/jack.png", color: "red" },
    { key: "ten", img: "/cards/10.png", color: "blue" },
    { key: "nine", img: "/cards/9.png", color: "lime" },
    { key: "eight", img: "/cards/8.png", color: "green" },
    { key: "seven", img: "/cards/7.png", color: "geekblue" },
    { key: "six", img: "/cards/6.png", color: "pink" },
    { key: "five", img: "/cards/5.png", color: "volcano" },
    { key: "four", img: "/cards/4.png", color: "magenta" },
    { key: "three", img: "/cards/3.png", color: "gold" },
    { key: "two", img: "/cards/2.png", color: "purple" },
    { key: "ace", img: "/cards/ace.png", color: "blue" },
];

const KingCup: React.FC = () => {
    const { t } = useTranslation();
    const cardRules = useMemo(
        () => CARD_CONFIGS.map((card) => ({
            ...card,
            label: t(`games.details.kingCup.cards.${card.key}.label`),
            rule: t(`games.details.kingCup.cards.${card.key}.rule`),
            description: t(`games.details.kingCup.cards.${card.key}.description`),
        })),
        [t]
    );

    return (
        <GamePage
            game="kingCup"
            tagColor="magenta"
            instructionIcons={[<CrownOutlined key="draw" />]}
        >
            <List
                className="king-cup__rules"
                dataSource={cardRules}
                renderItem={(item) => (
                    <List.Item key={item.key}>
                        <img
                            src={item.img}
                            alt={item.label}
                            width={50}
                            height={68}
                            style={{ objectFit: "contain" }}
                        />
                        <div className="king-cup__rule-copy">
                            <div><Tag color={item.color}>{item.label}</Tag><Text strong>{item.rule}</Text></div>
                            <Text type="secondary">{item.description}</Text>
                        </div>
                    </List.Item>
                )}
            />
        </GamePage>
    );
};

export default KingCup;
